import React, { useCallback, useEffect, useMemo, useState } from "react";
import Dropdown, {
  DropdownOption,
} from "../../../../components/inputs/Dropdown";
import { getAllStationIds } from "../../../../services/clearing/stations";

type Props = {
  valueCode: string;
  onChangeCode: (code: string) => void;
  placeholder?: string;
  className?: string;
  searchable?: boolean;
};

const StationIdDropdown: React.FC<Props> = ({
  valueCode,
  onChangeCode,
  placeholder = "Select a station",
  className,
  searchable = true,
}) => {
  const [options, setOptions] = useState<DropdownOption[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchOptions = useCallback(async () => {
    setLoading(true);
    try {
      const allStations = (await getAllStationIds()) || [];
      const stationOptions = allStations.map((id: string) => ({
        name: id,
        code: id,
      }));
      setOptions(stationOptions);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchOptions();
  }, [fetchOptions]);

  const selectedOption = useMemo(
    () => options.find((o) => o.code === valueCode) ?? null,
    [options, valueCode]
  );

  return (
    <Dropdown
      options={options}
      value={selectedOption}
      onChange={(opt) => onChangeCode(String(opt?.code ?? ""))}
      placeholder={loading ? "Loading stations..." : placeholder}
      className={className}
      searchable={searchable}
    />
  );
};

export default StationIdDropdown;
